import React from "react";
import PropTypes from "prop-types";

const RequiredField = ({ errorText }) => {
  return (
    <>
      {errorText !== null ? (
        <div className="invalid-feedback">{errorText}</div>
      ) : (
        <div className="invalid-feedback">Required Field</div>
      )}
    </>
  );
};

export default RequiredField;

RequiredField.propTypes = {
  errorText: PropTypes.string
};

RequiredField.defaultProps = {
  errorText: null
};
